import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-theme-black-transparent-80 top-0 left-0 w-full h-full fixed" }
const _hoisted_2 = { class: "custom-loading-wrapper" }
const _hoisted_3 = { class: "bg-theme-green w-[90%] md:w-[500px] py-[40px] px-[20px] flex flex-col mx-auto rounded-[16px]" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", {
          class: "mb-[15px] mt-[5px] text-white text-center",
          innerHTML: _ctx.message
        }, null, 8, _hoisted_4),
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"relative\" data-v-7efec4f2><div class=\"custom-loading\" data-v-7efec4f2><div class=\"bg-primary rect1\" data-v-7efec4f2></div><div class=\"bg-primary rect2\" data-v-7efec4f2></div><div class=\"bg-primary rect3\" data-v-7efec4f2></div><div class=\"bg-primary rect4\" data-v-7efec4f2></div><div class=\"bg-primary rect5\" data-v-7efec4f2></div></div></div>", 1))
      ])
    ])
  ]))
}